export const ALPHA_NUMERIC_REGEX = /^[a-z0-9]+$/i;

export const ONLY_NUMBER_REGEX = /^\d*$/;
